import { BaseAvailableApis, AbstractRouteType } from "..";

export default class BaseApi<
  A extends BaseAvailableApis,
  M = unknown,
  P = unknown,
  R = unknown
> {
  private _name: A;
  private owner!: AbstractRouteType;

  constructor(name: A) {
    this._name = name;
  }

  public use(meta: M): R {
    throw new Error("NotImplemented");
  }

  public get name(): A {
    return this._name;
  }

  protected getOwner() {
    return this.owner;
  }

  public onRouteBind(route: AbstractRouteType) {
    this.owner = route;
  }
}
